"use strict";

var _classCallCheck = require("/Users/RyoheiNagasawa/Portfolio/portfolio1/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/RyoheiNagasawa/Portfolio/portfolio1/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Plugins = void 0;

var Plugins = /*#__PURE__*/function () {
  function Plugins() {
    _classCallCheck(this, Plugins);
  }

  _createClass(Plugins, null, [{
    key: "getPlugin",
    value: function getPlugin(plugin) {
      return Plugins.plugins.filter(function (t) {
        return t.id === plugin;
      })[0];
    }
  }, {
    key: "addPlugin",
    value: function addPlugin(plugin) {
      if (!Plugins.getPlugin(plugin.id)) {
        Plugins.plugins.push(plugin);
      }
    }
  }, {
    key: "getAvailablePlugins",
    value: function getAvailablePlugins(container) {
      var res = new Map();
      var availablePlugins = Plugins.plugins.filter(function (t) {
        return t.needsPlugin(container.options);
      });
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = availablePlugins[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var plugin = _step.value;
          res.set(plugin.id, plugin.getPlugin(container));
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return res;
    }
  }, {
    key: "loadOptions",
    value: function loadOptions(options, sourceOptions) {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = Plugins.plugins[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var plugin = _step2.value;
          plugin.loadOptions(options, sourceOptions);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    }
  }, {
    key: "getPreset",
    value: function getPreset(preset) {
      return Plugins.presets.get(preset);
    }
  }, {
    key: "addPreset",
    value: function addPreset(presetKey, options) {
      if (!Plugins.getPreset(presetKey)) {
        Plugins.presets.set(presetKey, options);
      }
    }
  }, {
    key: "addShapeDrawer",
    value: function addShapeDrawer(type, drawer) {
      if (!Plugins.getShapeDrawer(type)) {
        Plugins.drawers.set(type, drawer);
      }
    }
  }, {
    key: "getShapeDrawer",
    value: function getShapeDrawer(type) {
      return Plugins.drawers.get(type);
    }
  }, {
    key: "getSupportedShapes",
    value: function getSupportedShapes() {
      return Plugins.drawers.keys();
    }
  }]);

  return Plugins;
}();

exports.Plugins = Plugins;
Plugins.plugins = [];
Plugins.presets = new Map();
Plugins.drawers = new Map();